import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import clsx from 'clsx';
function _InfoLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", d: "M13.737 21.848a10.002 10.002 0 0 0 6.697-15.221 10 10 0 1 0-6.698 15.221Z" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "square", d: "M12 12v6M12 7V6" })] }) });
}
const InfoLight = forwardRef(_InfoLight);
export { InfoLight };
